import { render, staticRenderFns } from "./OrderWesmartSideBar.vue?vue&type=template&id=5b9e73e8"
import script from "./OrderWesmartSideBar.vue?vue&type=script&lang=js"
export * from "./OrderWesmartSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports